import { Button, Container, Image } from 'react-bootstrap';
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaPaperPlane,
  FaPhoneAlt,
  FaPinterestP,
  FaTiktok,

  FaYoutube
} from 'react-icons/fa';
import ThymeToTurnipBeet from '../../assets/images/ThymeToTurnipBeet.png';
import '../home/HomeSection.css';

export const FooterSection = () => {
  return (
    <footer
      id="footer"
      className="footer"
    >
      <Container>
        <div className="d-flex w-100 justify-content-between flex-wrap">
          <div className="d-flex w-25 justify-content-between social-links flex-nowrap">
            <a
              href="https://www.facebook.com/StickyFingersCooking/"
              target="_blank"
              className="social-link"
              rel="noreferrer"
            >
              <FaFacebook size={20} />
            </a>
            <a
              href="https://www.instagram.com/stickyfingerscooking/"
              target="_blank"
              className="social-link"
              rel="noreferrer"
            >
              <FaInstagram size={20} />
            </a>
            <a
              href="https://www.pinterest.com/stickyfingersco/"
              target="_blank"
              className="social-link"
              rel="noreferrer"
            >
              <FaPinterestP size={20} />
            </a>
            <a
              href="https://www.youtube.com/channel/UC7eHBg7oDKChxsn4DC-69QA/featured"
              target="_blank"
              className="social-link"
              rel="noreferrer"
            >
              <FaYoutube size={20} />
            </a>
            <a
              href="https://www.tiktok.com/@stickyfingerscooking"
              target="_blank"
              className="social-link"
              rel="noreferrer"
            >
              <FaTiktok size={20} />
            </a>
          </div>

          <Button
            className="text-uppercase button-radius button-contact"
            onClick={() => {
              window.location.href = '/contact';
            }}
          >
            contact us
          </Button>
        </div>

        <div className="line-divider-footer second-style"></div>

        <div className="d-flex flex-wrap">
          <div className="footer-flex-child-logo">
            <div
              className="footer-logo w-inline-block"
            >
              <Image
                className="card-fruit"
                src={ThymeToTurnipBeet}
                alt="Denver digital agency web501 logo"
              />
            </div>
            <p className="paragraph-copyright">
              © {new Date().getFullYear()} Sticky Fingers Cooking
            </p>
          </div>
          <div className="footer-flex-child-menu">
            <div>
              <div className="subheader footer-menu">our programming</div>
              <a
                href="/sessions?session_type=after_school"
                className="footer-navigation"
              >
                School Enrichment Programs
              </a>
              <a
                href="/sessions?session_type=online"
                className="footer-navigation"
              >
                Online Cooking Classes
              </a>
              <a
                href="/sessions?session_type=camps"
                className="footer-navigation"
              >
                Cooking Camps
              </a>
              <a
                href="/school-programs/faqs"
                className="footer-navigation"
              >
                FAQs
              </a>
              <a
                  href="/why-we-are-grate#private-events"
                  className="footer-navigation"
              >
                Private Events
              </a>
              <a
                href="/recipes"
                className="footer-navigation"
              >
                Recipes
              </a>
              <a
                onClick={() =>
                  window.open(
                    'https://www.amazon.com/stores/author/B093YJHWSM/allbooks?ingress=0&visitId=40d233ce-6f77-44b4-88e1-623a39c5edc5&store_ref=ap_rdr&ref_=ap_rdr',
                    '_blank'
                  )
                }
                className="footer-navigation"
              >
                Shop
              </a>
              <a
                href="/sticky-notes"
                className="footer-navigation"
              >
                Sticky Notes
              </a>
            </div>
          </div>
          <div className="footer-flex-child-menu">
            <div data-ix="fade-up-2">
              <div className="subheader footer-menu">about us</div>
              <a
                href="/why-we-are-grate"
                className="footer-navigation"
              >
                About Sticky Fingers Cooking
              </a>
              <a href="/why-we-are-grate?tab=inTheNews" className="footer-navigation">
                Sticky Fingers in the News
              </a>
              <a
                href="/why-we-are-grate"
                className="footer-navigation"
              >
                Why We&#x27;re Grate
              </a>
              <a
                href="/why-we-are-grate"
                className="footer-navigation"
              >
                Testimonials
              </a>
              <a
                href="/about/our-crew"
                className="footer-navigation"
              >
                Our Crew
              </a>
              <a
                href="/availableJobs"
                className="footer-navigation"
              >
                Available Jobs
              </a>
              <a
                href="/nationwide"
                className="footer-navigation"
              >
                Locations
              </a>
              <a
                href="/media-inquiries"
                className="footer-navigation"
              >
                Media Inquiries
              </a>
              <a
                href="https://stickyfingerscookingfranchise.com/"
                target="_blank"
                className="footer-navigation"
              >
                Franchise Opportunities
              </a>
              <a
                href="/pages/privacy-policy-for-sticky-fingers-cooking-and-affiliates"
                className="footer-navigation"
              >
                Privacy Policy
              </a>
            </div>
          </div>
          <div className="footer-flex-child-contact">
            <div className="our-programming-content">
              <div className="subheader footer-menu">contact us</div>
              <div className="div-footer-contact address">
                <a
                  href="/"
                  target="_blank"
                  aria-current="page"
                  className="contact-link w--current"
                >
                  <FaPaperPlane
                    size={20}
                    className="me-2"
                  />
                </a>
                <div className="text-footer-contact">
                  {'3700 Tennyson St #12492'}
                  <br />
                  Denver, CO 80212
                </div>
              </div>
              <div className="div-footer-contact">
                <a
                  href="tel:303-648-4078"
                  className="contact-link"
                >
                  <FaPhoneAlt
                    size={20}
                    className="me-2"
                  />
                </a>
                <div className="text-footer-contact">
                  <a
                    href="tel:303-648-4078"
                    className="link-footer"
                  >
                    303-648-4078
                  </a>
                </div>
              </div>
              <div className="div-footer-contact">
                <a
                  href="mailto:hello@stickyfingerscooking.com"
                  className="contact-link"
                >
                  <FaEnvelope
                    size={20}
                    className="me-2"
                  />
                </a>
                <div className="text-footer-contact">
                  <a
                    href="mailto:hello@stickyfingerscooking.com"
                    className="link-footer"
                  >
                    hello@stickyfingerscooking.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};
